import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  standalone: true,
  selector: 'formly-separate-input',
  imports: [CommonModule, ReactiveFormsModule, FormlyModule],
  template: `
    <label class="field-label" [attr.for]="'formly_' + field.id">
      {{ to.label }}
      <span *ngIf="to.required" class="required">*</span>
    </label>

    <input
      class="field-input"
      [id]="'formly_' + field.id"
      [type]="to.type || 'text'"
      [formControl]="formControl"
      [formlyAttributes]="field"

      [attr.min]="to.min"
      [attr.max]="to.max"
      [attr.pattern]="to.pattern"
      [attr.required]="to.required ? '' : null"
      [attr.placeholder]="to.placeholder || null"
      [attr.inputmode]="to.type === 'tel' ? 'numeric' : to.inputmode || null"
      [ngClass]="{ invalid: showError }"
      [ngStyle]="to?.attributes?.style ? {'cssText': to.attributes.style} : null"
      [attr.aria-describedby]="to.description ? ('hint_' + field.id) : null"
    />
    <div *ngIf="to.description" class="field-hint" [id]="'hint_' + field.id">
      {{ to.description }}
    </div>

    <formly-validation-message
      class="field-error"
      [field]="field"
      *ngIf="showError && (formControl?.value?.toString().trim() !== '')">
    </formly-validation-message>
  `,
  styles: [`
    .field-label {
      display: block;
      margin-bottom: 6px;
      font-weight: 600;
      font-size: 14px;
    }
    .required {
      color: #dc2626;
      margin-left: 2px;
    }
    .field-input {
      width: 100%;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background: white;
      outline: none;
      transition: border-color 120ms ease-in-out, box-shadow 120ms ease-in-out;
      font-size: 14px;
      font-family: inherit;
    }
    .field-input:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
    }
    .field-input.invalid {
      border-color: #dc2626;
    }
    .field-error {
      margin-top: 4px;
      color: #dc2626;
      font-size: 12px;
    }
    .field-hint {
      margin-top: 4px;
      color: #6b7280;
      font-size: 12px;
    }
  `]
})
export class SeparateInputType extends FieldType {}